export class LanguageFormatValidator {
  public static isValidLanguage(languageCode: string) {
    return languageCode && /^[A-Za-z]{2}-[A-Za-z]{2}$/.test(languageCode);
  }
}
